import { WidgetDefinition } from '../models/WidgetDefinition';

export const AlarmsDisabledTableWidgetDefinition: WidgetDefinition = {
    baseType: 'AlarmsDisabledTable',
    group: 'Charts',
    hasImage: true,
    highlights: ['Alarms that are currently disabled'],
    icon: 'fa-table',
    sortingOrder: 1600,
    title: 'Disabled alarms table',
    type: 'AlarmsDisabledTable'
};